export const seasonBasedPriceDiscount = 2;
export const MAX_FILE_SIZE_MB = 20; // Max file size in MB

export const roles = {
    ADMIN: "ADMIN",
    USER: "USER",
    WRITER: "WRITER"
};

export const threadStatus = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const systemNotifications = {
    ORDER_CREATED: "Your order has been successfully created.",
    REQUIREMENT_SUBMITTED: "Your order requirements have been submitted.",
    PENDING_PAYMENT:
        "Your order is pending payment. Please complete the payment to proceed.",
    INPROGRESS_ORDER: "Your Order is now in progress.",
    ORDER_DELIVERED:
        "Your order has been delivered. Please review and accept the delivery.",
    ORDER_ACCEPTED:
        "Your order has been marked as completed. Thank you for using our service.",
    ORDER_COMPLETED_BY_ADMIN:
        "Your order has been marked as completed By The Admin. Thank you for using our service.",
    REQUEST_REVISION:
        "Your Review has been received. We will review it and respond shortly. .",
    COMPLAINET_RAISED:
        "Your complaint has been received. We will review it and respond shortly.",
    COMPLAINET_RESOLVED:
        "Your complaint has been resolved.",
    THANK_YOU_FOR_YOUR_PATIENCE: "Thank you for your patience."
};

export const providers = {
    LOCAL: "LOCAL",
    GOOGLE: "GOOGLE",
};

export const orderStatus = {
    REQUIREMENTS_SUBMITTED: "REQUIREMENTS_SUBMITTED",
    PENDING_PAYMENT: "PENDING_PAYMENT",
    PENDING_WRITER: "PENDING_WRITER",
    ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS",
    ORDER_DELIVERED: "ORDER_DELIVERED",
    IN_REVISION: "IN_REVISION",
    COMPLETED: "COMPLETED",
    COMPLAINT_RAISED: "COMPLAINT_RAISED",
    RESOLVED: "RESOLVED",
    CANCELLED: "CANCELLED"
};

export const reviewStatus = {
    ACTIVE: "ACTIVE",
    COMPLETED: "COMPLETED",
};

export const resolvedReasons = {
    REFUND: "Issue resolved with a refund",
    REVISION_PROVIDED: "Revision provided and approved by the client",
    MISUNDERSTANDING: "Misunderstanding clarified and resolved",
    COPLAINT_WITHDREW: "Client withdrew the complaint",
    NO_ACTION_REQUIRED: "No further action required; issue deemed invalid",
    COMPENSATION: "Compensation offered and accepted",
    MUTUAL_AGREEMENT: "Complaint resolved through mutual agreement"
}

// multipliers
export const TYPE_OF_PAPERS_MULTIPLIERS = [
    { name: "Essay (Any type)", paperTypeMultiplier: 1 },
    { name: "Discussion Post", paperTypeMultiplier: 1 },
    { name: "Research Paper", paperTypeMultiplier: 1 },
    { name: "Term Paper", paperTypeMultiplier: 1 },
    { name: "Thesis", paperTypeMultiplier: 1.5 },
    { name: "Dissertation", paperTypeMultiplier: 1.5 },
    { name: "Reflection Paper", paperTypeMultiplier: 1 },
    { name: "Argumentative Essay" , paperTypeMultiplier: 1 },
    { name: "Persuasive Essay", paperTypeMultiplier: 1 },
    { name: "Narrative Essay", paperTypeMultiplier: 1 },
    { name: "Literature Review", paperTypeMultiplier: 1.5 },
    { name: "Systematic Review", paperTypeMultiplier: 1.5 },
    { name: "Case Study", paperTypeMultiplier: 1 },
    { name: "Annotated Bibliography", paperTypeMultiplier: 1 },
    { name: "Lab Report", paperTypeMultiplier: 1 },
    { name: "Article Critique", paperTypeMultiplier: 1 },
    { name: "Policy Paper", paperTypeMultiplier: 1 },
    { name: "Business Plan", paperTypeMultiplier: 1 },
    { name: "Literary Analysis", paperTypeMultiplier: 1 },
    { name: "Expository Essay", paperTypeMultiplier: 1 },
    { ame: "Descriotive Essay", paperTypeMultiplier: 1 },
    { name: "Question-Answer", paperTypeMultiplier: 1 },
    { name: "Powerpoint", paperTypeMultiplier: 1 },
    { name: "Infographic", paperTypeMultiplier: 1.5 },
]

export const WRITING_TYPES_MULTIPLIERS = [
    { name: "Writing from scratch", writingTypeMultiplier: 1 },
    { name: "Editing", writingTypeMultiplier: 0.5 },
    { name: "Remove AI Content (Humanize)", writingTypeMultiplier: 0.5 },
    { name: "Rewriting", writingTypeMultiplier: 0.5 },
]

export const TYPE_OF_ENGLISH_MULTIPLIERS = [
    { id: 1, name: "US English", englishTypeMultiplier: 1 },
    { id: 2, name: "UK English", englishTypeMultiplier: 1.1 },
]

//identifiers
export const ACADEMIC_LEVEL_IDENTIFIERS = {
    COLLEGE: "College",
    UNIVERSITY: "University",
    MASTERS: "Masters",
    DOCTORATE: "Doctorate"
}

export const WRITING_TYPES_IDENTIFIERS = {
    WRITING_FROM_SCRATCH: "Writing from scratch",
    EDITING:  "Editing",
    REMOVE_AI_CONTENT:"Remove AI Content (Humanize)",
    REWRITING: "Rewriting", 
}

export const TYPE_OF_ENGLISH_INDETIFIERS = {
    US_ENGLISH: "US English",
    UK_ENGLISH: "UK English", 
}

export const SPACING_IDENTIFIERS = {
    DOUBLE_SPACING: "Double Spacing",
    SINGLE_SPACING: "Single Spacing" 
}


export const typeOfPapers = [
    "Essay (Any type)",
    "Discussion Post",
    "Research Paper",
    "Term Paper",
    "Thesis",
    "Dissertation",
    "Reflection Paper",
    "Argumentative Essay",
    "Persuasive Essay",
    "Narrative Essay",
    "Literature Review",
    "Systematic Review",
    "Case Study",
    "Annotated Bibliography",
    "Lab Report",
    "Article Critique",
    "Policy Paper",
    "Business Plan",
    "Literary Analysis",
    "Expository Essay",
    "Descriotive Essay",
    "Question-Answer",
    "Powerpoint",
    "Infographic",
];

export const academicLevels = [
    "College",
    "University",
    "Masters",
    "Doctorate",
];

export const deadlines = [
    "21 days",
    "14 days",
    "10 days",
    "06 days",
    "04 days",
    "02 days",
    "24 hours",
    "12 hours",
    "06 hours",
    "03 hours",
];

export const DEADLINES = [
    { name: "21 days", value: 21 },
    { name: "14 days", value: 14 },
    { name: "10 days", value: 10 },
    { name: "06 days", value: 6 },
    { name: "04 days", value: 4 },
    { name: "02 days", value: 2 },
    { name: "24 hours", value: 1 },
    { name: "12 hours", value: 0.5 },
    { name: "06 hours", value: 0.25 },
    { name: "03 hours", value: 0.125 },
]

export const spacings = [
    "Double Spacing",
    "Single Spacing",
];

export const referenceStyles = [
    "MLA",
    "APA",
    "Chicago",
    "Harvard",
    "Turabian",
    "Writer's Choice",
    "Not Applicable"
];

export const writerExperience = [
    "No Experience before",
    "Less than one year",   
    "1 - 2 years",
    "More than 2 years" 
]

export const paymentMethods = {
    PAYPAL: "PAYPAL",
    WALLET: "WALLET"
}

export const writerStatus = {
    ACTIVE: "ACTIVE",
    RESIGN: "RESIGN"
}

export const contactMethods = [
    "email",
    "phone"
]

export const preferedResolution = [
    "Refund",
    "Revision",
    "Explanation/Clarification",
    "Compensation"
]

export const referencesFormats = {
    // "image/jpeg": [],
    // "image/png": [],
    // "image/jpg": [],
    // "application/pdf": [],
    // "application/msword": [],
    // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], // .xlsx
    // "text/csv": [], // .csv
    // "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [], // .docx
    // "application/vnd.openxmlformats-officedocument.presentationml.presentation": [], // .pptx
    // "text/plain": [], // .txt
    
    "image/jpeg": [], // .jpeg
    "image/png": [],  // .png
    "image/jpg": [],  // .jpg
    "application/pdf": [], // .pdf
    "application/msword": [], // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [], // .docx
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], // .xlsx
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [], // .pptx
    "text/csv": [], // .csv
    "text/plain": [], // .txt
    "application/zip": [], // .zip
    "application/vnd.rar": [] // .rar    
}